import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";
import "@/App.css";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Loader } from "@/components/site/Loader";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { FloatingButtons } from "@/components/site/FloatingButtons";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";

const ScrollManager = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const t = setTimeout(() => {
                document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
            }, 350);
            return () => clearTimeout(t);
        }
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

function App() {
    const [loading, setLoading] = useState(true);

    return (
        <BrowserRouter>
            <AnimatePresence mode="wait">
                {loading && <Loader onDone={() => setLoading(false)} />}
            </AnimatePresence>

            <SmoothScroll>
                <ScrollManager />
                <div className="relative min-h-screen bg-ivory font-sans text-charcoal">
                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/projects/:id" element={<ProjectDetail />} />
                    </Routes>
                    <Footer />
                    <FloatingButtons />
                </div>
            </SmoothScroll>

            <Toaster position="top-center" richColors />
        </BrowserRouter>
    );
}

export default App;
